let isAddonSyncing = false;

if (typeof Shopify === "undefined") window.Shopify = {};
if (typeof Shopify.formatMoney !== "function") {
  Shopify.formatMoney = function (amount, format = "${{amount}}") {
    const v = (amount / 100).toFixed(2);
    return format.replace("{{amount}}", v);
  };
}

if (window.__P80UnifiedHandler__) {
  console.warn("[P80] Unified Add-on handler already initialized.");
} else {
  window.__P80UnifiedHandler__ = true;

  const P80State = {
    basePriceCents: 0,
    coreExtraCents: 0,
    warrantyExtraCents: 0,
  };

  function getCentsFromText(text) {
    return Number(String(text || "").replace(/[^0-9]/g, "")) || 0;
  }

  function recalcAndRenderPrice() {
    const priceEl = document.getElementById("CoreChargePrice");
    const hiddenCoreFinal = document.getElementById("CoreChargeFinalPrice");

    const coreFinal = P80State.basePriceCents + P80State.coreExtraCents;
    if (hiddenCoreFinal) hiddenCoreFinal.value = coreFinal;

    const finalCents = coreFinal + P80State.warrantyExtraCents;

    if (priceEl) {
      priceEl.textContent = Shopify.formatMoney(
        finalCents,
        window.theme?.moneyFormat || "${{amount}}"
      );
    }
  }
  function setAddToCartLoading(isLoading) {
    const btn =
      document.querySelector('#ProductForm button[name="add"]') ||
      document.querySelector('form[action="/cart/add"] button[name="add"]');

    if (!btn) return;

    const spinner = btn.querySelector('.loading__spinner');

    if (isLoading) {
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = true;
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
      btn.disabled = false;
      if (spinner) spinner.classList.add('hidden');
    }
  }

  

  /* ================= CORE CHARGE ================= */
  class CoreChargeHandler {
    constructor() {
      this.wrapper = document.getElementById("CoreChargeWrapper");
      if (!this.wrapper) return;

      this.radios = this.wrapper.querySelectorAll(
        'input[name="core_charge_option"]'
      );
      this.hiddenLabel = document.getElementById("CoreChargeProperty");
      this.hiddenAmount = document.getElementById("CoreChargeAmount");

      this.coreData = document.getElementById("core-charge-data");
      this.priceEl = document.getElementById("CoreChargePrice");
      this.variantInp = document.querySelector("input[name='id']");

      if (!this.coreData || !this.priceEl) return;

      this.coreChargeAmount =
        Number(this.coreData.dataset.coreChargeAmount) || 0;

      if (!P80State.basePriceCents) {
        P80State.basePriceCents = getCentsFromText(
          this.priceEl.textContent
        );
      }

      this.hiddenLabel.value = "Return Core in Advance";
      this.hiddenAmount.value = 0;
      P80State.coreExtraCents = 0;

      this.attachEvents();
      this.watchVariantChange();
    }


    attachEvents() {
      this.radios.forEach((radio) => {
        radio.addEventListener("change", () =>
          this.updateSelection(radio.value)
        );
      });
    }

    watchVariantChange() {
      if (!this.variantInp) return;

      const obs = new MutationObserver(() => {
        const variantInput = document.querySelector("input[name='id']");
        const variantPrice = Number(variantInput?.dataset?.price);
        if (variantPrice) {
          P80State.basePriceCents = variantPrice;
        }
        recalcAndRenderPrice();
      });

      obs.observe(this.variantInp, {
        attributes: true,
        attributeFilter: ["value"],
      });
    }

    updateSelection(choice) {
      const isDeposit = choice === "deposit";

      P80State.coreExtraCents = isDeposit
        ? this.coreChargeAmount
        : 0;

      this.hiddenLabel.value = isDeposit
        ? "Pay Core Charge"
        : "Return Core in Advance";

      this.hiddenAmount.value = P80State.coreExtraCents;

      recalcAndRenderPrice();
    }
  }

  /* ================= WARRANTY ================= */
  class WarrantyHandler {
    constructor() {
      if (!document.getElementById("WarrantyWrapper")) return;
      this.wrapper = document.getElementById("WarrantyWrapper");
      if (!this.wrapper) return;

      /* ===== Warranty radios ===== */
      this.radios = this.wrapper.querySelectorAll(
        'input[name="warranty_option"]'
      );

      /* ===== Hidden inputs (cart properties) ===== */
      this.hiddenLabel = document.getElementById("WarrantyOption");
      this.hiddenAmount = document.getElementById("WarrantyAmount");
      this.hiddenProdId = document.getElementById("WarrantyProductId");

      this.attrSigned = document.getElementById("AttrWarrantySigned");
      this.attrName = document.getElementById("AttrWarrantyName");
      this.attrEmail = document.getElementById("AttrWarrantyEmail");
      this.attrTimestamp = document.getElementById("AttrWarrantyTimestamp");

      /* ===== Modal elements ===== */
      this.modal = document.getElementById("WarrantyModal");
      this.openBtn = document.getElementById("WarrantyOpenModalButton");
      this.signBtn = document.getElementById("WarrantySignButton");
      this.closeBtn = document.getElementById("WarrantyCloseButton");

      this.modalName = document.getElementById("WarrantyModalName");
      this.modalEmail = document.getElementById("WarrantyModalEmail");
      this.modalAgree = document.getElementById("WarrantyModalAgree");

      /* ===== Signature UI ===== */
      this.signatureRow = document.getElementById("WarrantySignatureStatus");
      this.signatureIcon = document.getElementById("WarrantySignatureIcon");
      this.signatureText = document.getElementById("WarrantySignatureText");

      /* ===== Add to cart ===== */
      this.addToCartBtn =
      document.querySelector('#ProductForm button[name="add"]') ||
      document.querySelector('form[action="/cart/add"] button[name="add"]');

      this.disableAddToCart();

            /* ===== Initial state ===== */
      this.hiddenLabel.value = "";
      this.hiddenAmount.value = 0;
      this.hiddenProdId.value = "";
      P80State.warrantyExtraCents = 0;


      const defaultRadio = this.wrapper.querySelector(
        'input[name="warranty_option"]:checked'
      );

      if (defaultRadio) {
        this.updateWarranty(defaultRadio);
      }


      this.attachEvents();
      this.initSignedState();
    }

    /* =====================================================
      EVENTS
    ===================================================== */
    attachEvents() {
      this.radios.forEach((radio) => {
        radio.addEventListener("change", () =>
          this.updateWarranty(radio)
        );
      });

      this.openBtn?.addEventListener("click", () => this.openModal());
      this.closeBtn?.addEventListener("click", () => this.closeModal());
      this.signBtn?.addEventListener("click", () => this.signAgreement());

      this.modalName?.addEventListener("input", () => this.validateFields());
      this.modalEmail?.addEventListener("input", () => this.validateFields());
      this.modalAgree?.addEventListener("change", () => this.validateFields());

      document.addEventListener("keydown", (e) => {
        if (
          e.key === "Escape" &&
          this.modal &&
          !this.modal.classList.contains("hidden")
        ) {
          this.closeModal();
        }
      });

      this.modal?.addEventListener("click", () => this.closeModal());
      this.modal
        ?.querySelector(".warranty-modal__inner")
        ?.addEventListener("click", (e) => e.stopPropagation());
    }

    /* =====================================================
      WARRANTY SELECTION
    ===================================================== */
    updateWarranty(radio) {

    const labelEl = radio.closest("label");
    const label =
      labelEl?.querySelector(".wn-label")?.textContent.trim() || "";
    const priceText =
      labelEl?.querySelector(".wn-price")?.textContent || "+$0.00";

    const warrantyCents = getCentsFromText(priceText);

    this.hiddenLabel.value = label;
    this.hiddenAmount.value = warrantyCents;
    this.hiddenProdId.value = radio.value;

    P80State.warrantyExtraCents = warrantyCents;
    recalcAndRenderPrice();
    if (this.attrSigned?.value === "yes") {
      this.enableAddToCart();
    } else {
      this.disableAddToCart();
    }

    
  }


    /* =====================================================
      MODAL
    ===================================================== */
    openModal() {
      if (!this.modal) return;

      this.modal.classList.remove("hidden");
      document.body.classList.add("no-scroll");

      this.signBtn.disabled = true;
      this.signBtn.classList.add("disabled");
      this.validateFields();
    }

    closeModal() {
      if (!this.modal) return;

      this.modal.classList.add("hidden");
      document.body.classList.remove("no-scroll");
    }

    validateFields() {
      const valid =
        this.modalName?.value.trim() &&
        this.modalEmail?.value.includes("@") &&
        this.modalAgree?.checked;

      this.signBtn.disabled = !valid;
      this.signBtn.classList.toggle("disabled", !valid);
    }

    /* =====================================================
      SIGNATURE
    ===================================================== */
    signAgreement() {
      this.attrSigned.value = "yes";
      this.attrName.value = this.modalName.value.trim();
      this.attrEmail.value = this.modalEmail.value.trim();
      this.attrTimestamp.value = new Date().toISOString();

      this.closeModal();
      this.markAsSigned();
      this.enableAddToCart();
    }

    markAsSigned() {
      this.signatureRow?.classList.add("is-signed");

      document
        .getElementById("WarrantySignatureWrapper")
        ?.classList.add("is-signed");

      if (this.signatureIcon?.dataset?.signedIcon) {
        this.signatureIcon.innerHTML =
          this.signatureIcon.dataset.signedIcon;
      }

      if (this.signatureText) {
        this.signatureText.textContent = "Signed";
      }

      if (this.openBtn) {
        this.openBtn.textContent = "VIEW AGREEMENT";
      }
    }



    initSignedState() {
    if (this.attrSigned?.value === "yes") {
      this.markAsSigned();
      this.enableAddToCart();
    } else {
      this.disableAddToCart();
    }
  }

    /* =====================================================
      ADD TO CART CONTROL
    ===================================================== */
    disableAddToCart() {
      if (!this.addToCartBtn) return;
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.classList.add("disabled");
    }

    async enableAddToCart() {
      if (!this.addToCartBtn) return;

      const variantId = Number(
        document.querySelector("input[name='id']")?.value
      );

      const alreadyInCart = await isParentAlreadyInCart(variantId);
      if (alreadyInCart) return;

      this.addToCartBtn.disabled = false;
      this.addToCartBtn.classList.remove("disabled");
    }

  }

  async function isParentAlreadyInCart(variantId) {
    const cart = await (await fetch("/cart.js")).json();
    return cart.items.some(
      (item) =>
        Number(item.variant_id) === Number(variantId) &&
        !item.properties?._addon_type
    );
  }

  async function syncAddToCartDisabledState() {
    const addToCartBtn =
      document.querySelector('#ProductForm button[name="add"]') ||
      document.querySelector('form[action="/cart/add"] button[name="add"]');

    if (!addToCartBtn) return;

    //  Only apply logic if product HAS warranty
    const hasWarranty =
      document.getElementById("WarrantyWrapper") !== null;

    const hasCoreCharge =
      document.getElementById("CoreChargeWrapper") !== null;

    if (!hasWarranty && !hasCoreCharge) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove("disabled");
      return;
    }

    const variantId = Number(
      document.querySelector("input[name='id']")?.value
    );
    if (!variantId) return;

    const alreadyInCart = await isParentAlreadyInCart(variantId);
    const signed =
      !hasWarranty ||
      document.getElementById("AttrWarrantySigned")?.value === "yes";

    if (alreadyInCart || !signed) {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("disabled");
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove("disabled");
    }
  }



  /* ============================================================
     ADD-ON CART COMPLETION
  ============================================================ */
  document.addEventListener("DOMContentLoaded", () => {
    new CoreChargeHandler();
    new WarrantyHandler();

    syncAddToCartDisabledState();

    document.addEventListener("submit", async (e) => {
      const form = e.target;
      if (!form.matches('form[action="/cart/add"]')) return;

      const hasWarranty = document.getElementById("WarrantyWrapper") !== null;
      const hasCoreCharge = document.getElementById("CoreChargeWrapper") !== null;

      // Let Shopify handle normal products
      if (!hasWarranty && !hasCoreCharge) return;

      e.preventDefault(); //  prevent redirect to /cart

      setAddToCartLoading(true);

      if (form.dataset.p80Submitting) return;
      form.dataset.p80Submitting = "true";

      const formData = new FormData(form);
      const addedVariantId = Number(formData.get("id"));

      try {
        //  prevent duplicate parent add
        if (await isParentAlreadyInCart(addedVariantId)) return;

        /* ================= ADD PARENT ================= */
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        };

   

        // 1. Add parent
        await fetch("/cart/add.js", config);



        /* ================= WAIT FOR PARENT ================= */
        let parent = null;
        let attempts = 0;

        while (!parent && attempts < 10) {
          const cart = await (await fetch("/cart.js")).json();
          parent = cart.items.find(
            (item) =>
              Number(item.variant_id) === addedVariantId &&
              !item.properties?._addon_type
          );

          if (!parent) {
            await new Promise((r) => setTimeout(r, 150));
            attempts++;
          }
        }

        if (!parent) return;

        /* ================= CORE CHARGE ================= */
        const coreAmount = Number(
          document.getElementById("CoreChargeAmount")?.value || 0
        );
        const coreData = document.getElementById("core-charge-data");

        if (coreData && coreAmount > 0) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: coreData.dataset.coreChargeVariantId,
              quantity: parent.quantity,
              properties: {
                _addon_type: "core_charge",
                _parent_key: parent.key,
                _parent_variant_id: parent.variant_id,
              },
            }),
          });
        }

        /* ================= WARRANTY ================= */
        const warrantyVariantId =
          document.getElementById("WarrantyProductId")?.value;
        const warrantyAmount = Number(
          document.getElementById("WarrantyAmount")?.value || 0
        );

        if (warrantyVariantId && warrantyAmount > 0) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: warrantyVariantId,
              quantity: parent.quantity,
              properties: {
                _addon_type: "warranty",
                _parent_key: parent.key,
              },
            }),
          });
        }



   

        await syncAddToCartDisabledState();

      /* ================= FINAL CART RENDER ================= */

      // fetch sections ONCE
    const sectionResponse = await fetch(
      `${routes.cart_url}?sections=${cart
        .getSectionsToRender()
        .map((s) => s.id)
        .join(',')}`
    );

    const sections = await sectionResponse.json();

    // 🔴 FIX: pass FULL parsedState object
    cart.renderContents({
      id: addedVariantId,
      sections,
    });

    // 🔴 DO NOT reopen — renderContents already opens
    document.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );




      } finally {
        form.dataset.p80Submitting = "";
        setAddToCartLoading(false);
      }
    });

  });

}

/* ================= ADDON QUANTITY SYNC ================= */

document.addEventListener("cart:refresh", syncAddonQuantities);


async function syncAddonQuantities() {
  if (isAddonSyncing) return;
  isAddonSyncing = true;

  const cart = await (await fetch("/cart.js")).json();
  lockParentItemQuantity(cart);
  if (!cart?.items?.length) {
    isAddonSyncing = false;
    return;
  }

  const updates = {};

  cart.items.forEach((item) => {
    if (!item.properties?._addon_type) return;

    const parent = cart.items.find(
      (i) => i.key === item.properties._parent_key
    );

    if (!parent) {
      updates[item.key] = 0;
      return;
    }

    if (item.quantity !== parent.quantity) {
      updates[item.key] = parent.quantity;
    }
  });

  if (Object.keys(updates).length) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });
  }

  isAddonSyncing = false;
}


function lockParentItemQuantity(cart) {
  cart.items.forEach((item) => {
    // skip addon line items
    if (item.properties?._addon_type) return;

    //  THIS is the only reliable check
    if (
      item.properties?._has_warranty !== "true" &&
      item.properties?._has_core_charge !== "true"
    ) return;

    const input = document.querySelector(
      `.quantity__input[data-quantity-variant-id="${item.variant_id}"]`
    );
    if (!input) return;

    input.disabled = true;
    input.setAttribute("aria-disabled", "true");

    const wrapper = input.closest("quantity-input");
    if (!wrapper) return;

    wrapper.querySelectorAll(".quantity__button").forEach((btn) => {
      btn.disabled = true;
      btn.setAttribute("aria-disabled", "true");
    });
  });
}







document.addEventListener("change", (e) => {
  const qtyInput = e.target.closest(
    'input[name="updates[]"], .quantity__input'
  );
  if (!qtyInput) return;

  setTimeout(syncAddonQuantities, 150);
});






document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".quantity__button");
    if (!btn) return;

    const quantityInput = btn.closest("quantity-input");
    if (!quantityInput) return;

    const input = quantityInput.querySelector(".quantity__input");
    if (!input) return;

   
    if (input.disabled || input.hasAttribute("aria-disabled")) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  },
  true 
);




document.addEventListener("DOMContentLoaded", () => {
  subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    await syncAddonQuantities();
  });
});
